// extracted by mini-css-extract-plugin
module.exports = {"root":"Masterlists_root__1wWrK"};